import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import countryList from './countryList'; // Add this import at the top (create this file with all country names)
import { Helmet } from 'react-helmet';

const initialState = {
  full_name: '',
  email: '',
  username: '',
  password: '',
  profession: '',
  profile_image_url: '',
  bio: '',
  institution: '',
  department: '',
  position: '',
  research_interests: '',
  education: '',
  website: '',
  social_links: '',
  orcid_id: '',
  google_scholar_id: '',
  phone: '',
  address: '',
  country: '',
  languages: '',
  skills: '',
  achievements: '',
  profile_visibility: 'public',
  otherProfession: '',
  organization: '',
};

export default function Register() {
  const [form, setForm] = useState(initialState);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const insertData = {
      ...form,
      research_interests: form.research_interests ? form.research_interests.split(',').map(s => s.trim()) : [],
      education: form.education ? form.education.split(',').map(s => s.trim()) : [],
      languages: form.languages ? form.languages.split(',').map(s => s.trim()) : [],
      skills: form.skills ? form.skills.split(',').map(s => s.trim()) : [],
      achievements: form.achievements ? form.achievements.split(',').map(s => s.trim()) : [],
      social_links: form.social_links ? form.social_links : null,
    };
    const { error } = await supabase
      .from('users')
      .insert([insertData]);
    if (error) {
      setError(error.message);
    } else {
      setSuccess('Registration successful! You can now login.');
      setTimeout(() => navigate('/login'), 1500);
    }
  };

  return (
    <div className="register-page">
      <Helmet>
        <title>Register - darsgah-e-ahlebait</title>
        <meta name="description" content="Create a new account on darsgah-e-ahlebait." />
      </Helmet>
      <div className="row justify-content-center">
        <div className="col-lg-7">
      <h2 className="mb-4">Register</h2>
      <form onSubmit={handleSubmit}>
            <div className="row g-3">
              {/* First Row */}
              <div className="col-md-4">
                <label className="form-label">Full Name *</label>
                <input type="text" className="form-control" name="full_name" value={form.full_name} onChange={handleChange} required />
              </div>
              <div className="col-md-4">
                <label className="form-label">Email *</label>
                <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} required />
              </div>
              <div className="col-md-4">
                <label className="form-label">Username</label>
                <input type="text" className="form-control" name="username" value={form.username} onChange={handleChange} />
              </div>
              {/* Second Row */}
              <div className="col-md-4">
                <label className="form-label">Password *</label>
                <input type="password" className="form-control" name="password" value={form.password} onChange={handleChange} required />
              </div>
              <div className="col-md-4">
                <label className="form-label">Profession</label>
                <input type="text" className="form-control" name="profession" value={form.profession} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Other Profession</label>
                <input type="text" className="form-control" name="otherProfession" value={form.otherProfession} onChange={handleChange} />
              </div>
              {/* Third Row */}
              <div className="col-md-4">
                <label className="form-label">Profile Image URL</label>
                <input type="text" className="form-control" name="profile_image_url" value={form.profile_image_url} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Bio</label>
                <textarea className="form-control" name="bio" value={form.bio} onChange={handleChange} rows={2} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Institution</label>
                <input type="text" className="form-control" name="institution" value={form.institution} onChange={handleChange} />
              </div>
              {/* Fourth Row */}
              <div className="col-md-4">
                <label className="form-label">Organization</label>
                <input type="text" className="form-control" name="organization" value={form.organization} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Department</label>
                <input type="text" className="form-control" name="department" value={form.department} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Position</label>
                <input type="text" className="form-control" name="position" value={form.position} onChange={handleChange} />
              </div>
              {/* Fifth Row */}
              <div className="col-md-4">
                <label className="form-label">Research Interests (comma separated)</label>
                <input type="text" className="form-control" name="research_interests" value={form.research_interests} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Education (comma separated)</label>
                <input type="text" className="form-control" name="education" value={form.education} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Website</label>
                <input type="text" className="form-control" name="website" value={form.website} onChange={handleChange} />
              </div>
              {/* Sixth Row */}
              <div className="col-md-4">
                <label className="form-label">Social Links (JSON or comma separated)</label>
                <input type="text" className="form-control" name="social_links" value={form.social_links} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">ORCID ID</label>
                <input type="text" className="form-control" name="orcid_id" value={form.orcid_id} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Google Scholar ID</label>
                <input type="text" className="form-control" name="google_scholar_id" value={form.google_scholar_id} onChange={handleChange} />
              </div>
              {/* Seventh Row */}
              <div className="col-md-4">
                <label className="form-label">Phone</label>
                <input type="text" className="form-control" name="phone" value={form.phone} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Address</label>
                <input type="text" className="form-control" name="address" value={form.address} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Country *</label>
                <select className="form-select" name="country" value={form.country} onChange={handleChange} required>
                  <option value="">Select Country</option>
                  {countryList.map((country) => (
                    <option key={country} value={country}>{country}</option>
                  ))}
                </select>
              </div>
              {/* Eighth Row */}
              <div className="col-md-4">
                <label className="form-label">Languages (comma separated)</label>
                <input type="text" className="form-control" name="languages" value={form.languages} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Skills (comma separated)</label>
                <input type="text" className="form-control" name="skills" value={form.skills} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Achievements (comma separated)</label>
                <input type="text" className="form-control" name="achievements" value={form.achievements} onChange={handleChange} />
              </div>
              {/* Ninth Row */}
              <div className="col-md-4">
                <label className="form-label">Profile Visibility</label>
                <select className="form-select" name="profile_visibility" value={form.profile_visibility} onChange={handleChange}>
                  <option value="public">Public</option>
                  <option value="private">Private</option>
                </select>
              </div>
            </div>
            {error && <div className="alert alert-danger mt-3">{error}</div>}
            {success && <div className="alert alert-success mt-3">{success}</div>}
            <button type="submit" className="btn btn-success w-100 mt-4">Register</button>
          </form>
        </div>
        <div className="col-lg-5 d-none d-lg-block">
          <div className="bg-white shadow-sm rounded-4 p-4 ms-lg-4 mt-4 mt-lg-0">
            <h4 className="fw-bold mb-2 text-primary">Why Join Darsgah-e-Ahlebait?</h4>
            <ul className="list-unstyled mb-0">
              <li className="mb-2"><b>Access</b> to leading journals in science and Islamic research</li>
              <li className="mb-2"><b>Track</b> your submissions and reviews in a modern dashboard</li>
              <li className="mb-2"><b>Connect</b> with a global academic community</li>
              <li className="mb-2"><b>Showcase</b> your research and achievements</li>
              <li className="mb-2"><b>Stay updated</b> with the latest news and events</li>
            </ul>
            <div className="mt-3 text-secondary" style={{fontSize: '0.98rem'}}>Darsgah-e-Ahlebait is committed to advancing knowledge, fostering innovation, and bridging science and faith.</div>
          </div>
        </div>
        </div>
    </div>
  );
} 